import { render, staticRenderFns } from "./TagsTable.vue?vue&type=template&id=dcf4b48a&scoped=true&"
import script from "./TagsTable.vue?vue&type=script&lang=js&"
export * from "./TagsTable.vue?vue&type=script&lang=js&"
import style0 from "./TagsTable.vue?vue&type=style&index=0&id=dcf4b48a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf4b48a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
